export default "__VITE_ASSET__0hYimomh__"